import { downloadToDisk } from '@tcc-mono/shared/utils';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@tcc-mono/shared/app-config';
import { BaseService } from '@tcc-mono/shared/data-access';
import dayjs from 'dayjs';
import { Koppel } from '../../../models/src/lib/koppel.model';

@Injectable({
  providedIn: 'root'
})
export class ExcelService extends BaseService<any> {
  constructor(
    _http: HttpClient,
    @Inject(APP_CONFIG) appConfig: IAppConfig
  ) {
    super(_http, appConfig);
    this.path = 'api/excel';
  }

  getKoppelAnimals(koppel?: Koppel, all = false) {
    const date = dayjs().format('DD-MM-YYYY');
    const filename = koppel ? `Koppel_${koppel.number}_dieren_${date}.xlsx` : `Koppeldieren_${date}.xlsx`;
    const url = koppel ? `/koppels/${koppel.id.toString()}/animals` : '/koppels/animals';

    return this._http.get(this.getUrl(`${this.path}${url}`), { responseType: 'blob', params: { all: all } })
      .pipe(
        downloadToDisk(filename)
      );
  }

  getDailyReport = (date: string) => {
    const filename = `dagrapportage_${date}.xlsx`;
    return this._http.get(this.getUrl(`${this.path}/day/${date}`), { responseType: 'blob' })
      .pipe(
        downloadToDisk(filename)
      );
  };

  getVionDailyReport = (date: string) => {
    const filename = `slachtrunderen_dagrapportage_${date}.xlsx`;
    return this._http.get(this.getUrl(`${this.path}/vion_day/${date}`), { responseType: 'blob' })
      .pipe(
        downloadToDisk(filename)
      );
  };

  getProjectAnimals(startDate?: string, endDate?: string) {
    const date = dayjs().format('DD-MM-YYYY');
    const filename = `project_dieren_${date}.xlsx`;
    const url = `/project/animals`;

    return this._http.get(this.getUrl(`${this.path}${url}`), {
      responseType: 'blob',
      params: {
        ...(startDate && { start_date: startDate }),
        ...(endDate && { end_date: endDate })
      }
    })
      .pipe(
        downloadToDisk(filename)
      );
  }
}
